<template>
  <b-container fluid class="p-1">
  <b-navbar type="dark" variant="dark" class="isoverlap d-none d-lg-block">
    <b-container>
    <b-navbar-brand href="/" mx-auto>
      <img v-bind:src="$i18n.locale === 'fr' ? 'Images/cogir-rev-fr-110x110.png' : 'Images/cogir-rev-en-110x110.png'"
      class="d-inline-block align-top" alt="logo cogir">
    </b-navbar-brand>
    <!--<b-collapse id="nav-collapse" is-nav>-->
      <b-navbar-nav class="ml-auto">
        <div class="btn-group d-none d-md-block" role="group">
          <b-button size="sm" :variant="$i18n.locale === 'fr' ? 'light' : 'outline-light'" v-on:click="getLang('fr')">Français</b-button>
          <b-button size="sm" :variant="$i18n.locale === 'en' ? 'light' : 'outline-light'" v-on:click="getLang('en')">English</b-button>
        </div>
        <div class="btn-group d-block d-md-none" role="group">
          <b-button size="sm" :variant="$i18n.locale === 'fr' ? 'light' : 'outline-light'" v-on:click="getLang('fr')">Français</b-button>
          <b-button size="sm" :variant="$i18n.locale === 'en' ? 'light' : 'outline-light'" v-on:click="getLang('en')">English</b-button>
        </div>
      </b-navbar-nav>
    </b-container>
    <!--</b-collapse>-->
  </b-navbar>

  <!-- mobile -->
    <div class="text-center overlap d-none d-lg-block">
        <b-img src="Images/Image_Octopus.png" fluid alt="Octopus banderolle"></b-img>
    </div>

    <b-navbar type="dark" variant="dark" class="isoverlap d-block d-lg-none">
      <b-container>
      <b-navbar-brand href="/" mx-auto>
        <img v-bind:src="$i18n.locale === 'fr' ? 'Images/cogir-rev-fr-110x110.png' : 'Images/cogir-rev-en-110x110.png'"
        class="d-inline-block align-top" alt="logo cogir">
      </b-navbar-brand>
      <!--<b-collapse id="nav-collapse" is-nav>-->
        <b-navbar-nav class="ml-auto">
          <div class="btn-group d-none d-md-block" role="group">
            <b-button size="sm" :variant="$i18n.locale === 'fr' ? 'light' : 'outline-light'" v-on:click="getLang('fr')">Français</b-button>
            <b-button size="sm" :variant="$i18n.locale === 'en' ? 'light' : 'outline-light'" v-on:click="getLang('en')">English</b-button>
          </div>
          <div class="btn-group d-block d-md-none" role="group">
            <b-button size="sm" :variant="$i18n.locale === 'fr' ? 'light' : 'outline-light'" v-on:click="getLang('fr')">Français</b-button>
            <b-button size="sm" :variant="$i18n.locale === 'en' ? 'light' : 'outline-light'" v-on:click="getLang('en')">English</b-button>
          </div>
        </b-navbar-nav>
      </b-container>
      <!--</b-collapse>-->
    </b-navbar>

      <div class="text-center d-block d-lg-none mt-4">
          <b-img src="Images/Image_Octopus.png" fluid alt="Octopus banderolle"></b-img>
      </div>

</b-container>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
  },
  methods:{
    getLang: function (val) {
      this.$i18n.locale = val;
    }
  },
  components: {}
}
</script>
